import { createFileRoute } from '@tanstack/react-router'

import { ContactUsPage } from '~/boundedContext/settings/pages/contact-us'

export const Route = createFileRoute('/_main-layout/settings/contact-us')({
  component: ContactUsPage,
})
